export const COLOURS = { 
    social: '#DC0D15',
    club: '#D0CFD0',
    elite: '#F6C22E',
    black: '#222223',
    white: '#FFFFFF',
    gray: '#BFBFBF',
}

